import {useMemo} from 'react';
import {FlatOpaqueTextured} from '../../types/materials.js';
import {
    RotBMaterialContextValue,
    useRotBMaterialContext,
} from '../utils/rotb-material-context.js';
import {parseColor} from '../utils/utils.js';

export enum PowerupMaterialType {
    Default,
    RunOut,
    Locked,
    Perk,
    ComingSoon,
    DivotEmpty,
    DivotFull,
}

export const powerupMaterials = new Map<PowerupMaterialType, FlatOpaqueTextured | null>([
    [PowerupMaterialType.Default, null],
    [PowerupMaterialType.RunOut, null],
    [PowerupMaterialType.Locked, null],
    [PowerupMaterialType.Perk, null],
    [PowerupMaterialType.ComingSoon, null],
    [PowerupMaterialType.DivotEmpty, null],
    [PowerupMaterialType.DivotFull, null],
]);

export function usePowerupMaterial(
    materialType: PowerupMaterialType,
    baseMaterial: FlatOpaqueTextured | null,
    color: string
): FlatOpaqueTextured | null | undefined {
    // Check cache first
    const cachedMaterial = powerupMaterials.get(materialType);
    if (cachedMaterial) {
        return cachedMaterial;
    }

    // If not cached and base material is available, create it
    const newMaterial = baseMaterial.clone() as FlatOpaqueTextured;
    newMaterial.setColor(parseColor(color));
    powerupMaterials.set(materialType, newMaterial);
    return newMaterial;
}
